export const SET_AGE_SELECTION = "SET_AGE_SELECTION";
export const SET_AGE_VALUE = "SET_AGE_VALUE";
export const SET_AGE_STATE = "SET_AGE_STATE";
